import Button from '@mui/material/Button';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { toast } from 'react-toastify';

import './Login.scss';
import { useGameReducer } from '../../Store';
import { UserActions } from '../../Store/Actions';

export const LoginWithPass =  () => {
  const { t } = useTranslation();
  const [loginDetails, setLoginDetails] = useState({
    name: '',
    password: '',
  });

  const gameReducer = useGameReducer();

  useEffect(() => {
    if (gameReducer.token) {
      UserActions.getUserDetails();
    }
  }, [gameReducer.token]);

  const handleChange = (event) => {
    const field = event.target.name;
    const commonData = { ...loginDetails };
    commonData[field] = event.target.value;
    return setLoginDetails(commonData);
  };

  const login = () => {
    if (loginDetails.name && loginDetails.password) {
      UserActions.login(loginDetails).catch(() => {
        toast.error(t('error.invalidCredentials'), {autoClose: 3000});
      });
    } else {
      toast.error(t('error.invalidCredentials'), {autoClose: 3000});
    }
  };

  return (
    <div className='login_div'>
      <input
        id='name'
        type='text'
        name='name'
        className='input_box'
        placeholder={t('login.username')}
        value={loginDetails.name}
        onChange={handleChange}
      />
      <input
        id='password'
        type='password'
        name='password'
        className='input_box'
        placeholder={t('login.password')}
        value={loginDetails.password}
        onChange={handleChange}
      />
      <Button variant='contained' className='header_btn' onClick={login}>
        {t('login.submitButton')}
      </Button>
    </div>
  );
};
